import { createRouter, type RouterInstance } from '@crown/router';
import { getPageMeta } from './content/content-manifest';
import { routerConfig } from './router-config';
import { initChrome, setActiveNav, setBranding } from './ui';

declare global {
  interface Window {
    docsRouter?: RouterInstance;
  }
}

function syncChrome(routePath: string) {
  const meta = getPageMeta(routePath);
  setBranding(meta.title, meta.subtitle);
  setActiveNav(routePath);

  try {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  } catch {
    window.scrollTo(0, 0);
  }
}

export async function bootstrap() {
  initChrome();

  const router = createRouter(routerConfig);
  window.docsRouter = router;

  router.addAfterNavigateHook(({ to }: { to: string }) => {
    syncChrome(to);
  });

  router.init({
    linkSelector: 'a[data-route-link="true"]',
    onRouteChange: async (route: string) => {
      syncChrome(route);
    },
  });

  syncChrome(
    router.state.currentRoute.get() || routerConfig.defaultRoute || '',
  );

  return router;
}
